module.exports = __webpack_public_path__ + "static/offer-clip-e4be0168a40c4331d711a72d8ed667fb.png";